import moment from "moment"

// Een mailto: mag niet eindeloos lang zijn, Outlook kapt rond de 2000 tekens af, en een
// afgekapte URL levert een lege of stukke concept-mail op. Liever bewust inkorten met een
// zichtbare markering dan de client laten raden.
const MAX_BODY_LENGTH = 1600

const line = (label, value) => (value ? `${label}: ${value}\n` : "")

/**
 * De technische kant van een foutmelding, klaar om als e-mail te versturen.
 *
 * De dialoog toont de gebruiker alleen de melding zelf; tijdstip, functienaam en foutcode zeggen
 * hem niets en maakten het scherm alleen drukker. Voor wie de fout moet oplossen zijn ze juist het
 * enige bruikbare, dus komen ze hier terecht, samen met de pagina en de browser, want dezelfde
 * melding op een andere route betekent vaak iets anders.
 *
 * Bewust in het Engels, ongeacht de taal van de app: de ontvanger is de beheerder, niet de melder.
 * En bewust zonder persoonsgegevens in de tekst, het mailprogramma van de gebruiker zet zijn eigen
 * afzender er al bij, en die hoeft er niet nog een keer in.
 */
export const buildErrorReport = (errors = [], context = {}) => {
  const { url, userAgent } = context

  const body = errors.map((error, index) => {
    const at = error.key ? moment(error.key).format("YYYY-MM-DD HH:mm:ss") : null

    return `${errors.length > 1 ? `${index + 1}. ` : ""}${error.message || "Unknown error"}\n`
      + line("   Function", error.function)
      + line("   Time", at)
      + line("   Code", error.number)
      + line("   Level", error.level)
  }).join("\n")

  const footer = "\n---\n"
    + line("Page", url)
    + line("Browser", userAgent)

  const full = `The following ${errors.length === 1 ? "error" : "errors"} occurred:\n\n${body}${footer}`

  return full.length > MAX_BODY_LENGTH
    ? `${full.slice(0, MAX_BODY_LENGTH)}\n… report truncated`
    : full
}

export const buildErrorReportMailto = (errors = [], email, context = {}) => {
  const subject = errors.length === 1
    ? "Eggspedition, error report"
    : `Eggspedition, error report (${errors.length} errors)`

  return `mailto:${email}?subject=${encodeURIComponent(subject)}`
    + `&body=${encodeURIComponent(buildErrorReport(errors, context))}`
}
